/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ViolationType {
  OVERTIME="OVERTIME",
TIME_WINDOWS="TIME_WINDOWS",
CAPACITY="CAPACITY",
OUT_OF_REGION="OUT_OF_REGION",
TAGS="TAGS"
}

/**
* ViolationType
 *
 * Types of planning violations
*/
export const ViolationTypeEnumType = types.enumeration("ViolationType", [
        "OVERTIME",
  "TIME_WINDOWS",
  "CAPACITY",
  "OUT_OF_REGION",
  "TAGS",
      ])
